import { render } from "./Colors.vue?vue&type=template&id=2471a6ea&scoped=true"
import script from "./Colors.vue?vue&type=script&lang=js"
export * from "./Colors.vue?vue&type=script&lang=js"

import "./Colors.vue?vue&type=style&index=0&id=2471a6ea&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2471a6ea"]])

export default __exports__